// A header checkbox that checks/unchecks every row checkbox at once.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["all", "item"]

  toggleAll() {
    this.itemTargets.forEach((checkbox) => { checkbox.checked = this.allTarget.checked })
  }
}
